import chartOptions from './ChartOptions.js'

export default {
  // stepSize: null,
  // maxSize: null,
  // isFixedScale: true,
  mode: 'channels',
  keySalesStatsArray: [],
  isOnlyCompleted: false,
  isUpToToday: true,
  isIncVat: false,
  isLast: false,
  correction: 1,
  period: 'Dit kwartaal',
  periodArray: {
    'Dit jaar': 'this-year',
    'Dit kwartaal': 'this-quarter',
    'Deze maand': 'this-month',
    'Deze week': 'this-week',
    'Vandaag': 'this-day',
    '--------------': '',
    'Vorig jaar': 'last-year',
    'Vorig kwartaal': 'last-quarter',
    'Vorige maand': 'last-month',
    'Vorige week': 'last-week',
    'Gisteren': 'last-day'
  },
  amount: 10,
  amountArray: [1, 4, 7, 10],
  totals: {},
  revenueArrays: {},
  labelArray: {},
  maxItemLength: 0,
  totalRevenue: [0, 0],
  totalOrders: [0, 0],
  revenuePerOrder: [0, 0],
  totalProducts: [0, 0],
  productsPerOrder: [0, 0],
  dataCollection: [{}, {}],
  index: [0, 1],
  fields: {
    name: {
      label: 'Product',
      thStyle: 'width: 40%;',
      sortable: true
    },
    total_revenue: {
      label: 'Omzet',
      thStyle: 'width: 15%;',
      sortable: true
    },
    total_revenue_last_year: {
      label: '(vorig jaar)',
      thStyle: 'width: 15%;',
      sortable: false
    },
    total_sold: {
      label: 'Aantal',
      thStyle: 'width: 15%;',
      sortable: true
    },
    total_sold_last_year: {
      label: '(vorig jaar)',
      thStyle: 'width: 15%;',
      sortable: false
    }
  },
  allProducts: {},
  detailModalProductId: null,
  chartOptions: chartOptions
}



// WEBPACK FOOTER //
// ./src/reports/dataBlock.js